import { render, staticRenderFns } from "./EntityTableSelectedRowsActionMenu.vue?vue&type=template&id=8b37596a&"
import script from "./EntityTableSelectedRowsActionMenu.vue?vue&type=script&lang=js&"
export * from "./EntityTableSelectedRowsActionMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports